.header {
	position: absolute;
	top: 2rem;
	right: 2rem;
	z-index: 1;

	@media (max-width: 768px) {
		position: relative;
		top: 0;
		right: 0;
		margin-bottom: 1rem;
	}
}
